export default {
    name: 'statistic-item',
    props: {
        color: {
            type: String
        },
        label: {
            type: String
        },
        isTime: {
            type: Boolean,
            default: false
        },
        isPercent: {
            type: Boolean,
            default: false
        },
        totalPoints: {},
        correctPoints: {}
    },
    computed: {
        progressPercent() {
            return Math.round((100 / this.totalPoints) * this.correctPoints)
        }
    },
    methods: {
        convertToMinutes(duration) {
            const minutes = Math.round(Math.floor(duration / 60));
            const seconds = duration % 60;
            return minutes
            // return `${minutes>9 ? minutes : '0'+minutes} : ${seconds>9 ? seconds : '0'+seconds}`
        }
    }
}
